<div class="page-shell">
  <div class="page">
    <div class="hero">
      <div class="hero-text">
        <span class="eyebrow">Atlas</span>
        <h2>Launch your tenant in minutes</h2>
        <p>Register your tenant and pick the plan that fits your rollout.</p>
      </div>
      <div class="hero-panel">
        <div class="step-pill">Step {{ currentStep === 'tenantInfo' ? '1' : '2' }} of 2</div>
        <div class="hero-title">Atlas Signup</div>
        <div class="hero-subtitle">
          {{ currentStep === 'tenantInfo' ? 'Tell us about your tenant.' : 'Choose an Atlas plan.' }}
        </div>
      </div>
    </div>

    <div class="content">
      @if (currentStep === 'tenantInfo') {
      <section class="card">
        <app-tenant-info [startingForm]="userForm.get('tenantInfo')?.value" [finalForm]="true" [status]="status"
          (subformInitialized)="subformInitialized('tenantInfo', $event)"
          (submitForm)="submitRegistration()"></app-tenant-info>
      </section>
      }

      @if (currentStep === 'subscription') {
      <section class="card">
        <div class="card-header">
          <h3>Select your Atlas plan</h3>
          <p>Upgrade any time. Billing starts after checkout.</p>
          @if (registeredTenantId) {
          <div class="helper">Subscribing tenant: {{ registeredTenantId }}</div>
          }
        </div>

        @if (plansLoading) {
        <div class="helper">Loading plans...</div>
        }
        @if (plansError) {
        <div class="helper">{{ plansError }}</div>
        }
        @if (!plansLoading && !plansError) {
        <div class="plan-grid">
          @for (plan of plans; track plan.subscriptionLevel) {
          <button type="button" class="plan-card" [class.selected]="selectedPlan === plan" (click)="selectPlan(plan)"
            [disabled]="status.loading">
            <div class="plan-title">{{ plan.displayName }}</div>
            <div class="plan-price">{{ formatPlanPrice(plan) }} <span>/ {{ planInterval(plan) }}</span></div>
            <div class="plan-detail">{{ plan.displayDetail }}</div>
          </button>
          }
        </div>
        }

        <div class="actions">
          <button mat-raised-button color="primary" (click)="continueToCheckout()"
            [disabled]="!canContinueToCheckout()">
            Continue to Checkout
          </button>
          @if (subscriptionBlocked && subscriptionBlockMessage) {
          <div class="helper">{{ subscriptionBlockMessage }}</div>
          }
          @if (status.loading) {
          <div class="helper">Redirecting to checkout...</div>
          }
          @if (!status.loading) {
          <div class="helper">You can change plans later in Atlas.</div>
          }
        </div>
      </section>
      }
    </div>
  </div>
</div>